import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return n(), l("svg", r, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.87 2.402A1 1 0 0 1 18.67 2h2.5a1 1 0 1 1 0 2h-1.998l-3.56 4.772a11.5 11.5 0 0 1 .97 2.47 9 9 0 0 1 .002 4.255c-.26 1.154-1.01 1.778-1.736 2.108a3.66 3.66 0 0 1-7.003 1.069 3.7 3.7 0 0 1-.221-.695H3a1 1 0 1 1 0-2h5.558a1 1 0 0 1 .996 1.09 2 2 0 0 0-.008.15v.002a1.662 1.662 0 1 0 3.31-.206 1 1 0 0 1 .772-1.1c.261-.06.49-.155.66-.288a.95.95 0 0 0 .347-.575l.005-.02a7 7 0 0 0 .003-3.302c-.533-1.917-1.314-2.973-2.037-3.58-.72-.606-1.464-.834-2.06-.957-2.12-.354-5.255-.33-7.39.005a1 1 0 0 1-.31-1.976c2.331-.366 5.696-.395 8.05.002l.033.006c.768.156 1.881.479 2.964 1.389q.25.209.49.457z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_trunk-4AqszWiZ.js.map
